import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { timeout, map } from 'rxjs/operators';

const mainUrl = environment.url;

@Injectable({
  providedIn: 'root'
})
export class ConditionService {

  constructor(private http: HttpClient) { }

  getAllConditions(): Observable<any> {
    return this.http.get(mainUrl + 'param-conditions')
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  createCondition(form): Observable<any> {
    return this.http.post(mainUrl + 'param-condition', form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getConditionById(id): Observable<any> {
    return this.http.get(mainUrl + 'param-condition/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  updateCondition(id, form): Observable<any> {
    return this.http.put(mainUrl + 'param-condition/' + id, form)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  deleteCondition(id): Observable<any> {
    return this.http.delete(mainUrl + 'param-condition/' + id)
      .pipe(
        timeout(30000),
        map((res: any) => res.data)
      )
  }

  getHeader() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': window.localStorage.getItem('token')
     });

    return headers;
  }
}